// ----------------------------------------------------------------------

export default function Typography(theme) {
    return {
        MuiTypography: {
            component: "div",
            styleOverrides: {
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
            },
        },
    }
}
